export type DashboardDrilldownScope = Record<string, string | number | boolean | undefined | null>;

export type DashboardDrilldownResult = {
  readonly enabled: boolean;
  readonly path: string;
  readonly query: Record<string, string>;
  readonly reason?: string | undefined;
};

const metricMappings: Record<string, Record<string, string>> = {
  "open-complaints": { metric: "open-complaints", status: "open" },
  "overdue-complaints": { metric: "overdue-complaints", slaState: "overdue" },
  "sla-breached": { metric: "sla-breached", slaState: "breached" },
  "rca-pending": { metric: "rca-pending", stage: "rca" },
  "capa-pending": { metric: "capa-pending", stage: "capa" },
  "verification-pending": { metric: "verification-pending", stage: "verification" },
  "evidence-pending": { metric: "evidence-pending", evidenceState: "pending" },
  open: { metric: "open-complaints", status: "open" },
  sla: { metric: "sla-breached", slaState: "breached" },
  rca: { metric: "rca-pending", stage: "rca" },
  capa: { metric: "capa-pending", stage: "capa" },
  verification: { metric: "verification-pending", stage: "verification" },
  evidence: { metric: "evidence-pending", evidenceState: "pending" },
   "near-breach": { metric: "near-breach", slaState: "near-breach" },
  "critical-complaints": { metric: "critical-complaints", priority: "critical" },
  "assigned-to-me": { metric: "assigned-to-me", assigned: "me" },
  "pending-verification": { metric: "pending-verification", stage: "verification" },
  "repeat-complaints": { metric: "repeat-complaints", repeat: "true" },
  "closed-this-month": { metric: "closed-this-month", status: "closed" },
  "average-closure-time": { metric: "average-closure-time" },
};

export function mapDashboardMetricToDrilldown(metricKey: string, scope: DashboardDrilldownScope = {}, basePath = "/cmts/complaints"): DashboardDrilldownResult {
const normalized = metricKey
  .trim()
  .toLowerCase()
  .replace(/_/g, "-");
    const mapped = metricMappings[normalized];
  if (!mapped) return { enabled: false, path: basePath, query: {}, reason: `Unsupported dashboard metric '${metricKey}'.` };
  const query: Record<string, string> = { ...mapped };
  for (const [key, value] of Object.entries(scope)) {
    if (value === undefined || value === null || String(value).trim() === "") continue;
    query[key] = String(value);
  }
  return { enabled: true, path: buildPath(basePath, query), query };
}

export function buildDashboardDrilldownPath(basePath: string, query: Record<string, string | number | boolean | undefined | null>): string {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(query)) {
    if (value === undefined || value === null || String(value).trim() === "") continue;
    params.set(key, String(value));
  }
  const serialized = params.toString();
  return serialized ? `${basePath}?${serialized}` : basePath;
}

function buildPath(basePath: string, query: Record<string, string>): string {
  return buildDashboardDrilldownPath(basePath, query);
}
